<template>

  <div>

    <!-- search -->
    <div class="input-group mb-2">
      <div class="input-group-prepend">
        <span class="input-group-text bg-white border-right-0">
          <i class="fa-solid fa-magnifying-glass text-muted"></i>
        </span>
      </div>
      <input
        :value="search"
        type="text"
        class="form-control border-left-0"
        :placeholder="$t('Search conversations')"
        @input="onSearch($event.target.value)">
    </div>

    <!-- assigned -->
    <div class="mb-2">
      <button
        v-for="option in assignedOptions"
        :key="option.value"
        type="button"
        class="btn btn-block btn-sm assigned-btn d-flex justify-content-between align-items-center mb-1"
        :class="{ 'btn-secondary': filters.assigned === option.value }"
        @click="update('assigned', option.value)">
        <span class="text-truncate">{{ option.label }}</span>
        <span
          v-if="option.count !== null"
          class="badge badge-pill"
          :class="filters.assigned === option.value ? 'badge-light' : 'badge-secondary'">{{ option.count }}</span>
      </button>
    </div>

    <!--
    agente
    a opção "sem responsável" já traz o agente desligado embutido, então não há
    o que escolher aqui
    -->
    <div
      v-if="showAgent"
      class="input-group input-group-sm mb-2">
      <div class="input-group-prepend">
        <span class="input-group-text bg-white border-right-0">
          <i class="fa-solid fa-robot text-muted"></i>
        </span>
      </div>
      <select
        class="form-control border-left-0"
        :title="$t('Agent')"
        :value="agent"
        @change="update('agent', $event.target.value)">
        <option
          v-for="option in agentOptions"
          :key="option.value"
          :value="option.value">{{ option.label }}</option>
      </select>
    </div>

    <!-- unreplied -->
    <div class="form-check">
      <input
        id="filter-unreplied"
        type="checkbox"
        class="form-check-input"
        :checked="filters.unreplied"
        @change="update('unreplied', $event.target.checked)">
      <label
        class="form-check-label"
        for="filter-unreplied">{{ $t('Unreplied') }}</label>
    </div>

  </div>

</template>

<script>
export default {
  name: 'ConversationFilters',
  props: {
    filters: {
      type: Object,
      default: () => ({ assigned: 'all', agent: 'any', unreplied: false })
    },
    // { all, mine, unassigned }
    facets: {
      type: Object,
      default: () => ({})
    },
    search: {
      type: String,
      default: ''
    },
    debounce: {
      type: Number,
      default: 350
    }
  },
  data () {
    return {
      searchTimer: null
    }
  },
  computed: {
    /*
    assignedOptions
    os totais vêm do nó facets da busca; o badge some enquanto a primeira
    resposta não chega
    */
    assignedOptions () {
      return [
        { value: 'all', label: this.$t('All'), count: this.count('all') },
        { value: 'me', label: this.$t('Mine'), count: this.count('mine') },
        {
          value: 'unassigned',
          label: this.$t('No owner'),
          title: this.$t('Agent off and nobody assigned'),
          count: this.count('unassigned')
        }
      ]
    },
    agentOptions () {
      return [
        { value: 'off', label: this.$t('No agent') },
        { value: 'on', label: this.$t('With agent') },
        { value: 'any', label: this.$t('Any') }
      ]
    },
    // o agente só é escolhido em "todas" e "minhas"
    showAgent () {
      return this.filters.assigned !== 'unassigned'
    },
    // sem escolha, o agente não filtra nada
    agent () {
      return this.filters.agent || 'any'
    }
  },
  beforeDestroy () {
    clearTimeout(this.searchTimer)
  },
  methods: {
    /*
    count
    o total de um facet; null enquanto a api não respondeu
    */
    count (key) {
      const value = this.facets ? this.facets[key] : null
      return typeof value === 'number' ? value : null
    },
    /*
    update
    emits a new filters object with the changed field
    */
    update (key, value) {
      this.$emit('update:filters', { ...this.filters, [key]: value })
    },
    /*
    onSearch
    debounces the search so we don't hit the API on every keystroke
    */
    onSearch (value) {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.$emit('update:search', value)
      }, this.debounce)
    }
  }
}
</script>

<style scoped>
/*
o anel de foco do bootstrap fica preso no botão depois do clique, porque o
botão continua focado. some com ele no clique de mouse, mas mantém na
navegação por teclado
*/
.assigned-btn {
  -webkit-tap-highlight-color: transparent;
}
.assigned-btn:focus:not(:focus-visible),
.assigned-btn:active:focus:not(:focus-visible) {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/sidebar/ConversationFilters.vue